import { writable } from 'svelte/store';
export const emptyContact = {
    id: 0,
    email: "",
    first_name: "",
    last_name: "",
    id_ecosystem_enterprise: 0,
    job_fr: "",
    job_en: "",
    linkedin: "",
    photo: "",
    telephone: ""
};
export const emptyEcosystem = {
    id: 0,
    name: "",
    logo: "",
    website: "",
    id_partner_level: 0,
    description_fr: "",
    description_en: "",
    date_partner: "",
    why_fr: "",
    why_en: "",
    date_creation: "",
    nb_collab: 0,
    nb_project: 0,
    the_small_plus_fr: "",
    the_small_plus_en: "",
    published: false,
    logo_home: "",
    categories: [],
    clients: [],
    contact: emptyContact,
    events: "",
};
export const storeEcosystems = writable([]);
export const storeEcosystemsError = writable("");
export const storeEcosystemId = writable(0);
export const storeEcosystemCategories = writable([]);
export const storeEcosystemCategory = writable("");
export const storeEcosystemCategoriesError = writable("");
export const storePartners = writable([]);
